import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout__search-state" }
const _hoisted_2 = { class: "layout__search-state-alert" }
const _hoisted_3 = { class: "layout__search-state-text" }
const _hoisted_4 = {
  key: 0,
  class: "layout__search-state-string"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "layout__search-state-help" }

import { toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
interface SEARCH_MESSAGE {
  alert: string
  text: string
  imgSource: string
  help: Array<string>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutSearchState',
  props: {
  empty: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  },
  searchString: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const { t } = useI18n()

const props = __props
const { empty, error } = toRefs(props)
const message: SEARCH_MESSAGE = {
  alert: empty.value
    ? t('general__text__search-empty-alert')
    : t('general__text__search-error-alert'),
  text: empty.value ? t('general__text__search-empty-text') : t('general__text__search-error-text'),
  imgSource: empty.value
    ? require('@/design-system/assets/images/Illustration-Pictogram-Empty.svg')
    : require('@/design-system/assets/images/Illustration-Pictogram-Error.svg'),
  help: empty.value
    ? [
        t('general__text__search-empty-help-1'),
        t('general__text__search-empty-help-2'),
        t('general__text__search-empty-help-3')
      ]
    : [t('general__text__search-error-help-1'), t('general__text__search-error-help-2')]
}
function handleSupport() {
  window.open('mailto: support@digitalbuildings.ai?subject=ZDB support')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(message.alert), 1),
    _createElementVNode("div", _hoisted_3, [
      (_unref(empty))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(message.text), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", null, _toDisplayString(message.text.split('. ')[0]), 1),
            _createElementVNode("div", null, _toDisplayString(message.text.split('. ')[1]), 1)
          ], 64))
    ]),
    (_unref(empty))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "\"" + _toDisplayString(__props.searchString) + "\"", 1))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: message.imgSource,
      class: "layout__search-state-img"
    }, null, 8, _hoisted_5),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.help, (help) => {
        return (_openBlock(), _createElementBlock("li", { key: help }, _toDisplayString(help), 1))
      }), 128))
    ]),
    (_unref(error))
      ? (_openBlock(), _createBlock(ButtonText, {
          key: 1,
          class: "layout__search-state-support-btn",
          "button-text": _unref(t)('general__text__support'),
          size: "small",
          "icon-left": require(`@/design-system/assets/icons/Icon-Mail.svg`),
          onOnClicked: handleSupport
        }, null, 8, ["button-text", "icon-left"]))
      : _createCommentVNode("", true)
  ]))
}
}

})